import debounce from 'lodash.debounce';

interface TimelineItemProps {
    el: HTMLElement;
}

const DEBOUNCE_VALUE = 10;

const TimelineItem = ({ el }: TimelineItemProps): void => {
    const windowScrollCheck = (): void => {
        const rect = el.getBoundingClientRect();
        const isInView = (
            rect.top <= 0 ||
            rect.top <= ((window.innerHeight || document.documentElement.clientHeight) / 2)
        );

        if (isInView) {
            el.classList.add('in-view');
        }
    };

    windowScrollCheck();

    window.addEventListener('resize', debounce(windowScrollCheck, DEBOUNCE_VALUE));
    window.addEventListener('scroll', debounce(windowScrollCheck, DEBOUNCE_VALUE));
};

export default TimelineItem;
